import React from "react";
import Header from "./Components/Header";
import WhoWeAre from "./Components/WhoWeAre";
import Products from "./Components/Products";
import Footer from "./Components/Footer";
import Banner from './Components/Banner';

function App() {
  return (
    <div>
      <Header />
      <WhoWeAre />
      <Banner />
      <Products />
      <Footer />
    </div>
  );
}

export default App;
